/**
 * Cuộn lên đầu trang khi pathname thay đổi (React Router).
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToPageTop } from '../../shared/utils/scrollToPageTop';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToPageTop();
  }, [pathname]);

  return null;
};
